import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _69601c2e = () => interopDefault(import('..\\pages\\centerMain.vue' /* webpackChunkName: "pages/centerMain" */))
const _2c7bbc22 = () => interopDefault(import('..\\pages\\centerMain\\account.vue' /* webpackChunkName: "pages/centerMain/account" */))
const _6bbc680a = () => interopDefault(import('..\\pages\\centerMain\\order\\after-sales.vue' /* webpackChunkName: "pages/centerMain/order/after-sales" */))
const _04b839ee = () => interopDefault(import('..\\pages\\centerMain\\order\\order.vue' /* webpackChunkName: "pages/centerMain/order/order" */))
const _46eb5240 = () => interopDefault(import('..\\pages\\centerMain\\order\\order-detail.vue' /* webpackChunkName: "pages/centerMain/order/order-detail" */))
const _459ac3ec = () => interopDefault(import('..\\pages\\centerMain\\order\\template.vue' /* webpackChunkName: "pages/centerMain/order/template" */))
const _6f193dab = () => interopDefault(import('..\\pages\\centerMain\\personalization\\wishlist.vue' /* webpackChunkName: "pages/centerMain/personalization/wishlist" */))
const _4ba004f3 = () => interopDefault(import('..\\pages\\centerMain\\settings\\address.vue' /* webpackChunkName: "pages/centerMain/settings/address" */))
const _1930d55f = () => interopDefault(import('..\\pages\\centerMain\\settings\\Info.vue' /* webpackChunkName: "pages/centerMain/settings/Info" */))
const _3d0ce42c = () => interopDefault(import('..\\pages\\centerMain\\settings\\password.vue' /* webpackChunkName: "pages/centerMain/settings/password" */))
const _337f11ab = () => interopDefault(import('..\\pages\\centerMain\\settings\\prescription.vue' /* webpackChunkName: "pages/centerMain/settings/prescription" */))
const _402d8d2e = () => interopDefault(import('..\\pages\\centerMain\\settings\\subscription.vue' /* webpackChunkName: "pages/centerMain/settings/subscription" */))
const _6564b722 = () => interopDefault(import('..\\pages\\centerMain\\tickets\\my-tickets.vue' /* webpackChunkName: "pages/centerMain/tickets/my-tickets" */))
const _5d6c4cd5 = () => interopDefault(import('..\\pages\\centerMain\\tickets\\tickets-history.vue' /* webpackChunkName: "pages/centerMain/tickets/tickets-history" */))
const _20371014 = () => interopDefault(import('..\\pages\\centerMain\\wallet\\coupons.vue' /* webpackChunkName: "pages/centerMain/wallet/coupons" */))
const _4d1245c0 = () => interopDefault(import('..\\pages\\centerMain\\wallet\\wallet.vue' /* webpackChunkName: "pages/centerMain/wallet/wallet" */))
const _62a0816b = () => interopDefault(import('..\\pages\\contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _706ca4e6 = () => interopDefault(import('..\\pages\\control.vue' /* webpackChunkName: "pages/control" */))
const _0e7c8356 = () => interopDefault(import('..\\pages\\control\\index.vue' /* webpackChunkName: "pages/control/index" */))
const _e6a79bb6 = () => interopDefault(import('..\\pages\\control\\language.vue' /* webpackChunkName: "pages/control/language" */))
const _69963496 = () => interopDefault(import('..\\pages\\control\\search.vue' /* webpackChunkName: "pages/control/search" */))
const _05f8e21c = () => interopDefault(import('..\\pages\\control\\_type.vue' /* webpackChunkName: "pages/control/_type" */))
const _963f801c = () => interopDefault(import('..\\pages\\details.vue' /* webpackChunkName: "pages/details" */))
const _9fb75d6c = () => interopDefault(import('..\\pages\\details\\_code.vue' /* webpackChunkName: "pages/details/_code" */))
const _5b940494 = () => interopDefault(import('..\\pages\\payment.vue' /* webpackChunkName: "pages/payment" */))
const _c428c3e8 = () => interopDefault(import('..\\pages\\payment\\index.vue' /* webpackChunkName: "pages/payment/index" */))
const _838cd028 = () => interopDefault(import('..\\pages\\payment-success.vue' /* webpackChunkName: "pages/payment-success" */))
const _55c407c2 = () => interopDefault(import('..\\pages\\product.vue' /* webpackChunkName: "pages/product" */))
const _41f570fa = () => interopDefault(import('..\\pages\\product\\index.vue' /* webpackChunkName: "pages/product/index" */))
const _625ed5b0 = () => interopDefault(import('..\\pages\\search.vue' /* webpackChunkName: "pages/search" */))
const _70b0ec90 = () => interopDefault(import('..\\pages\\search\\accessories.vue' /* webpackChunkName: "pages/search/accessories" */))
const _41064621 = () => interopDefault(import('..\\pages\\search\\_type.vue' /* webpackChunkName: "pages/search/_type" */))
const _48a54e28 = () => interopDefault(import('..\\pages\\shoppingCart.vue' /* webpackChunkName: "pages/shoppingCart" */))
const _7ce8495a = () => interopDefault(import('..\\pages\\shoppingCart\\index.vue' /* webpackChunkName: "pages/shoppingCart/index" */))
const _7cfacd01 = () => interopDefault(import('..\\pages\\unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _87468072 = () => interopDefault(import('..\\pages\\why-choose-stylool.vue' /* webpackChunkName: "pages/why-choose-stylool" */))
const _c3ee56fc = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _44cbc9c0 = () => interopDefault(import('..\\pages\\index\\index.vue' /* webpackChunkName: "pages/index/index" */))
const _42211722 = () => interopDefault(import('..\\pages\\index\\about-us\\index.vue' /* webpackChunkName: "pages/index/about-us/index" */))
const _65a2507e = () => interopDefault(import('..\\pages\\index\\faq\\index.vue' /* webpackChunkName: "pages/index/faq/index" */))
const _ce7ce770 = () => interopDefault(import('..\\pages\\index\\faq\\_articles.vue' /* webpackChunkName: "pages/index/faq/_articles" */))
const _a9800f6e = () => interopDefault(import('..\\pages\\_type.vue' /* webpackChunkName: "pages/_type" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/centerMain",
    component: _69601c2e,
    name: "centerMain",
    children: [{
      path: "account",
      component: _2c7bbc22,
      name: "centerMain-account"
    }, {
      path: "order/after-sales",
      component: _6bbc680a,
      name: "centerMain-order-after-sales"
    }, {
      path: "order/order",
      component: _04b839ee,
      name: "centerMain-order-order"
    }, {
      path: "order/order-detail",
      component: _46eb5240,
      name: "centerMain-order-order-detail"
    }, {
      path: "order/template",
      component: _459ac3ec,
      name: "centerMain-order-template"
    }, {
      path: "personalization/wishlist",
      component: _6f193dab,
      name: "centerMain-personalization-wishlist"
    }, {
      path: "settings/address",
      component: _4ba004f3,
      name: "centerMain-settings-address"
    }, {
      path: "settings/Info",
      component: _1930d55f,
      name: "centerMain-settings-Info"
    }, {
      path: "settings/password",
      component: _3d0ce42c,
      name: "centerMain-settings-password"
    }, {
      path: "settings/prescription",
      component: _337f11ab,
      name: "centerMain-settings-prescription"
    }, {
      path: "settings/subscription",
      component: _402d8d2e,
      name: "centerMain-settings-subscription"
    }, {
      path: "tickets/my-tickets",
      component: _6564b722,
      name: "centerMain-tickets-my-tickets"
    }, {
      path: "tickets/tickets-history",
      component: _5d6c4cd5,
      name: "centerMain-tickets-tickets-history"
    }, {
      path: "wallet/coupons",
      component: _20371014,
      name: "centerMain-wallet-coupons"
    }, {
      path: "wallet/wallet",
      component: _4d1245c0,
      name: "centerMain-wallet-wallet"
    }]
  }, {
    path: "/contact-us",
    component: _62a0816b,
    name: "contact-us"
  }, {
    path: "/control",
    component: _706ca4e6,
    children: [{
      path: "",
      component: _0e7c8356,
      name: "control"
    }, {
      path: "language",
      component: _e6a79bb6,
      name: "control-language"
    }, {
      path: "search",
      component: _69963496,
      name: "control-search"
    }, {
      path: ":type",
      component: _05f8e21c,
      name: "control-type"
    }]
  }, {
    path: "/details",
    component: _963f801c,
    name: "details",
    children: [{
      path: ":code?",
      component: _9fb75d6c,
      name: "details-code"
    }]
  }, {
    path: "/payment",
    component: _5b940494,
    children: [{
      path: "",
      component: _c428c3e8,
      name: "payment"
    }]
  }, {
    path: "/payment-success",
    component: _838cd028,
    name: "payment-success"
  }, {
    path: "/product",
    component: _55c407c2,
    children: [{
      path: "",
      component: _41f570fa,
      name: "product"
    }]
  }, {
    path: "/search",
    component: _625ed5b0,
    name: "search",
    children: [{
      path: "accessories",
      component: _70b0ec90,
      name: "search-accessories"
    }, {
      path: ":type?",
      component: _41064621,
      name: "search-type"
    }]
  }, {
    path: "/shoppingCart",
    component: _48a54e28,
    children: [{
      path: "",
      component: _7ce8495a,
      name: "shoppingCart"
    }]
  }, {
    path: "/unsubscribe",
    component: _7cfacd01,
    name: "unsubscribe"
  }, {
    path: "/why-choose-stylool",
    component: _87468072,
    name: "why-choose-stylool"
  }, {
    path: "/",
    component: _c3ee56fc,
    children: [{
      path: "",
      component: _44cbc9c0,
      name: "index"
    }, {
      path: "about-us",
      component: _42211722,
      name: "index-about-us"
    }, {
      path: "faq",
      component: _65a2507e,
      name: "index-faq"
    }, {
      path: "faq/:articles",
      component: _ce7ce770,
      name: "index-faq-articles"
    }]
  }, {
    path: "/:type",
    component: _a9800f6e,
    name: "type"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
